/**
 * Şablon dilleri (ISO 639-1).
 *
 * RIS ile aynı liste — builder her iki üründe de aynı dil kodlarını kullanır.
 * unit_forms.language eskiden serbest metindi ("Türkçe"); NormalizeUnitFormLanguage migration'ı ile
 * bu kodlara çevrildi.
 */
export const TemplateLanguages = ['tr', 'en', 'de', 'fr', 'es', 'ru', 'az', 'uz']

export default TemplateLanguages
